//
// Suggestion mixin
// ----------------

define(function(require, exports, module) {
    'use strict';

    module.exports = {

        additionalEvents: {
            'tap .fn-validate': 'handleSuggestion'
        },

        /**
         * Use suggested name for input
         * @param  {Node}   input
         * @param  {String} value
         */
        suggestion: function(input, value) {
            input.value = value;
            input.focus();
        },

        /**
         * Use suggestion as value if user clicks
         * @param  {Event} e
         */
        handleSuggestion: function(e) {
            if (e.target.classList.contains('fn-suggestion')) {
                var input = e.currentTarget.querySelector('input');
                var value = e.target.innerHTML;

                e.preventDefault();

                this.suggestion(input, value);
            }
        }

    };
});